import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

// Main site files
import Home from './components/Home';
import RecycleProcess from './components/RecycleProcess';
import LoginPage from './components/login';
import Registration from './components/Registration';
import Fuelstations from './components/Fuelstations';
import Evstations from './components/Evchargestations';
import MobilebillPay from './components/MobileBill-Pay';
import Rewards_Center from './components/Invest-portfolio';
import Redemption from './components/Redemption';
import RedemptionLogin from './components/Redemptionlogin';
import About from './components/Aboutus';
import RecycleItems from './components/RecycleItems';
import Contact from './components/Contact';

// Protected Route
import ProtectedRoute from './components/ProtectedRoute';
import DriverProtectedRoute from './components/DriverProtectedRoute';
import RedemProtectedRoute from './components/RedemProtectedRoute';

// Layout files
import Layout from './components/Layout';
import CustLayout from './components/CustLayout';
import RedemLayout from './components/RedempLayout';

// Css files
import './App.css';

//Customer
import Myaccount from './components/customer/Myaccount';
import Requestpickup from './components/customer/RequestPickup';
import CustomerSchedule from './components/customer/CustomerSchedule';
import Pickuphistory from './components/customer/PickupHistory';
import CustomerPendingFund from './components/customer/PendingFund';
import RequestBag from './components/customer/RequestBag';
import CustomerPaymentFund from './components/customer/PaymentHistory';
import InvestNow from './components/customer/InvestNow';

// Driver
import DriverDashboard from './components/driver/DriverDashboard';
import DriverPickupHistory from './components/driver/DriverPickupHistory';
import ViewPickupHistory from './components/driver/ViewPickupHistory';
import ScanPickup from './components/driver/ScanPickup';
import DriverSchedule from './components/driver/DriverSchedule';
import PendingFund from './components/driver/PendingFund';
import PaymentSettings from './components/driver/PaymentSettings';
import DriverPaymentHistory from './components/driver/PaymentHistory';

// Redemption
import Redem_Das from './components/redemption/Redemptiondashboard';
import Redem_Acc from './components/redemption/Redemptionaccount';
import RedmCustomerList from './components/redemption/CustomerList';
import RedmAddCustomer from './components/redemption/AddCustomer';
import RedmViewCustomer from './components/redemption/ViewCustomer';
import RedmEditCustomer from './components/redemption/EditCustomer';
import RedmDriverList from './components/redemption/DriverList';
import RedmAddDriver from './components/redemption/AddDriver';
import RedmViewDriver from './components/redemption/ViewDriver';
import RedmEditDriver from './components/redemption/EditDriver';
import PickupRequests from './components/redemption/RedemPickupRequest';
import RedemAssign from './components/redemption/RedemAssign';
import ViewPickupRequest from './components/redemption/ViewPickupRequest';
import RedmSchedule from './components/redemption/RedemAdminSchedule';
import RedemCustomerpayments from './components/redemption/RedemCustomerPayments';
import RedemDriverpayments from './components/redemption/RedemDriverPayments';
import ViewCustPay from './components/redemption/ViewCustpay';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Main site */}
          <Route path="/" element={<Home />} />
          <Route path="/recycle-process" element={<RecycleProcess />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<Registration />} />
          <Route path="/fuel-gas-stations" element={<Fuelstations />} />
          <Route path="/ev-charging-stations" element={<Evstations />} />
          <Route path="/rewards_center" element={<Rewards_Center />} />
          <Route path="/mobile-bill-pay" element={<MobilebillPay />} />
          <Route path="/redemption-center" element={<Redemption />} />
          <Route path="/redemption-login" element={<RedemptionLogin />} />
          <Route path="/about" element={<About />} />
          <Route path="/recycle-items" element={<RecycleItems />} />
          <Route path="/contact" element={<Contact />} />

          {/* Customer Protected Routes */}
          <Route path="/account" element={
            <ProtectedRoute> <CustLayout><Myaccount /></CustLayout> </ProtectedRoute>
          } />
          <Route path="/request-pickup" element={
            <ProtectedRoute> <CustLayout><Requestpickup /></CustLayout> </ProtectedRoute>
          } />
          <Route path="/pickup-history" element={
            <ProtectedRoute> <CustLayout><Pickuphistory /></CustLayout> </ProtectedRoute>
          } />
          <Route path="/customer/pendingfund" element={
            <ProtectedRoute> <CustLayout><CustomerPendingFund /></CustLayout> </ProtectedRoute>
          } />
          <Route path="/customer/paymentfund" element={
            <ProtectedRoute> <CustLayout><CustomerPaymentFund /></CustLayout> </ProtectedRoute>
          } />
          <Route path="/customer-schedule" element={
            <ProtectedRoute> <CustLayout><CustomerSchedule /></CustLayout> </ProtectedRoute>
          } />
          <Route path="/request-bag" element={
            <ProtectedRoute> <CustLayout><RequestBag /></CustLayout> </ProtectedRoute>
          } />
          <Route path="/customer/invest-now" element={
            <ProtectedRoute> <CustLayout><InvestNow /></CustLayout> </ProtectedRoute>
          } />

          {/* Driver Protected Routes */}
          <Route path="/driver" element={
              <DriverProtectedRoute> <Layout> <DriverDashboard /> </Layout> </DriverProtectedRoute>
            }/>
          <Route path="/driverpickuphistory" element={
              <DriverProtectedRoute> <Layout> <DriverPickupHistory /> </Layout> </DriverProtectedRoute>
            } />
          <Route path="/view-pickup/:pickup_id" element={
              <DriverProtectedRoute> <Layout><ViewPickupHistory /> </Layout></DriverProtectedRoute>
            }/>
          <Route path="/scan-pickup/:pickup_id" element={
              <DriverProtectedRoute> <Layout> <ScanPickup /> </Layout> </DriverProtectedRoute>
            }/>
          <Route path="/driver-schedule" element={
            <DriverProtectedRoute><Layout> <DriverSchedule /> </Layout> </DriverProtectedRoute>
          }/>
          <Route path="/driverpaymenthistory" element={
              <DriverProtectedRoute> <Layout><DriverPaymentHistory /> </Layout> </DriverProtectedRoute>
            } />
          <Route path="/driverpendingfund" element={
              <DriverProtectedRoute> <Layout> <PendingFund /> </Layout></DriverProtectedRoute>
            } />
          <Route path="/paymentsettings" element={
              <DriverProtectedRoute> <Layout> <PaymentSettings /> </Layout> </DriverProtectedRoute>
            }/>

          {/* Redemption Protected Routes */} 
          <Route path="/redem-account" element={ 
            <RedemProtectedRoute> <RedemLayout> <Redem_Acc /> </RedemLayout> </RedemProtectedRoute>
          } />
          <Route path="/redem-dashboard" element={
            <RedemProtectedRoute> <RedemLayout> <Redem_Das /> </RedemLayout> </RedemProtectedRoute>
          }/>
          <Route path="/redem-customerlist" element={
            <RedemProtectedRoute> <RedemLayout> <RedmCustomerList /> </RedemLayout> </RedemProtectedRoute>
          }
          />
          <Route path="/redem-addcustomer" element={ 
            <RedemProtectedRoute><RedemLayout> <RedmAddCustomer /> </RedemLayout> </RedemProtectedRoute>
          } />
          <Route path="/redem-editcustomer/:id" element={
            <RedemProtectedRoute> <RedemLayout> <RedmEditCustomer /> </RedemLayout> </RedemProtectedRoute>
          }
          />
          <Route path="/redem-viewcustomer/:id" element={
            <RedemProtectedRoute> <RedemLayout> <RedmViewCustomer /> </RedemLayout> </RedemProtectedRoute>
          }
          />
          <Route path="/redem-driverlist" element={
            <RedemProtectedRoute> <RedemLayout> <RedmDriverList /> </RedemLayout> </RedemProtectedRoute>
          }/>
          <Route path="/redem-adddriver" element={
            <RedemProtectedRoute> <RedemLayout> <RedmAddDriver /> </RedemLayout> </RedemProtectedRoute>
          }/>
          <Route path="/redem-editdriver/:id" element={
            <RedemProtectedRoute> <RedemLayout> <RedmEditDriver /> </RedemLayout> </RedemProtectedRoute>
          }/>
          <Route path="/redem-viewdriver/:id" element={
            <RedemProtectedRoute> <RedemLayout> <RedmViewDriver /> </RedemLayout> </RedemProtectedRoute>
          }/>
          <Route path="/redem-pickuprequests" element={
            <RedemProtectedRoute> <RedemLayout>  <PickupRequests /> </RedemLayout> </RedemProtectedRoute>
          } />
          <Route path="/redem-assign-pickupreq/:id" element={
            <RedemProtectedRoute><RedemLayout> <RedemAssign /> </RedemLayout> </RedemProtectedRoute>
          }
          />
          <Route path="/redem-view-pickupreq/:id" element={
            <RedemProtectedRoute> <RedemLayout>  <ViewPickupRequest /> </RedemLayout> </RedemProtectedRoute>
          }/>
          <Route path="/redem-schedule" element={
            <RedemProtectedRoute> <RedemLayout> <RedmSchedule /> </RedemLayout></RedemProtectedRoute>
          } />
          <Route path="/redem-customer-payments" element={
              <RedemProtectedRoute> <RedemLayout> <RedemCustomerpayments /> </RedemLayout></RedemProtectedRoute>
            }/>
          <Route path="/redem-driver-payments"element={
              <RedemProtectedRoute> <RedemLayout><RedemDriverpayments /> </RedemLayout> </RedemProtectedRoute>
            }/>
          <Route path="/redem-customer-payments/:id" element={
              <RedemProtectedRoute> <RedemLayout> <ViewCustPay /></RedemLayout></RedemProtectedRoute>
            }/>
        </Routes>
      </div>
    </Router>
  );
}

export default App;

